export default "__VITE_PUBLIC_ASSET__d983e061__"